// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"e2b7d94d","507":"802e9a15","540":"aaee604e","553":"7585cf20","589":"5ac87685","668":"cc4a671e","767":"cadc395d","803":"0c653911","825":"cff4bd81","851":"19344320","917":"08d86668","984":"e20f79d1","988":"623d0399"}[chunkId] + ".chunk.js";
};